import React, { useState } from 'react'
import s from './ShareDrawer.module.scss'
import { ReactComponent as LinkIcon } from 'images/new-icons/link.svg';
import { ReactComponent as DiscordIcon } from 'images/new-icons/social-medias/discord.svg';
import { ReactComponent as EmailIcon } from 'images/new-icons/social-medias/email.svg';
import { ReactComponent as FacebookIcon } from 'images/new-icons/social-medias/facebook.svg';
import { ReactComponent as MessengerIcon } from 'images/new-icons/social-medias/messenger.svg';
import { ReactComponent as SmsIcon } from 'images/new-icons/social-medias/sms.svg';
import { ReactComponent as SnapchatIcon } from 'images/new-icons/social-medias/snapchat.svg';
import { ReactComponent as TwitterIcon } from 'images/new-icons/social-medias/twitter.svg';
import { ReactComponent as WhatsAppIcon } from 'images/new-icons/social-medias/whatsapp.svg';
import { ToastContainer, toast } from 'react-toastify';

const mediaList = [
    {
        icon: <TwitterIcon />,
        name: "Twitter",
        shareUrl: (url) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`
    },
    {
        icon: <FacebookIcon />,
        name: "Facebook",
        shareUrl: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
    },
    {
        icon: <MessengerIcon />,
        name: "Messenger",
        shareUrl: (url) => `https://www.facebook.com/dialog/send?app_id=1882309892128285&link=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`
    },
    {
        icon: <EmailIcon />,
        name: "Email",
        shareUrl: (url) => `mailto:?body=${encodeURIComponent(url)}`
    },
    {
        icon: <SmsIcon />,
        name: "Sms",
        shareUrl: (url) => `sms:?body=${encodeURIComponent(url)}`
    },
    {
        icon: <SnapchatIcon />,
        name: "Snapchat",
        shareUrl: (url) => `https://www.snapchat.com/share?url=${encodeURIComponent(url)}`
    },
    {
        icon: <DiscordIcon />,
        name: "Discord",
        shareUrl: (url) => `https://discord.com/channels/@me?content=${encodeURIComponent(url)}`
    },
    {
        icon: <WhatsAppIcon />,
        name: "WhatsApp",
        shareUrl: (url) => `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`
    },
]


const MediaList = ({ setIsCopied }) => {
    const [showCopyText, setShowCopyText] = useState(false)

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setIsCopied(true)
            setShowCopyText(true)
            setTimeout(() => {
                setIsCopied(false)
                setShowCopyText(false)
            }, 2000)
        } catch (err) {
            console.error('Error copying link:', err);
        }
    }

    const handleShare = (item) => {
        if (item.shareUrl) {
            const url = item.shareUrl(window.location.href);
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <div className={s.media_list}>
            <div className={s.media_list_item} onClick={handleCopyLink} >
                <div className={s.media_list_copy_icon}>
                    <LinkIcon />
                </div>
                <div className={s.media_list_title}>
                    {showCopyText ? "Copied" : "Copy"}
                </div>
            </div>
            {mediaList.map((item) => (
                <div
                    key={item.name}
                    className={s.media_list_item}
                    onClick={() => handleShare(item)}
                >
                    <div className={s.media_list_icons}>
                        {item.icon}
                    </div>
                    <div className={s.media_list_title}>{item.name}</div>
                </div>
            ))}
        </div>
    )
}

export default MediaList